/**
 * 模块: 竞品ASIN表格列定义
 * 职责: 定义竞品ASIN表格的列配置
 * 限制: <80行
 */

import React from 'react';
import { Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { CompetitorASIN } from '../../types';

export const competitorColumns: ColumnsType<CompetitorASIN> = [
  {
    title: 'ASIN',
    dataIndex: 'asin',
    key: 'asin',
    fixed: 'left',
    width: 160,
    render: (value: string) => <strong>{value}</strong>,
  },
  {
    title: '品牌',
    dataIndex: 'brand',
    key: 'brand',
    width: 160,
  },
  {
    title: '威胁等级',
    dataIndex: 'threat_level',
    key: 'threat_level',
    render: (value: string) => {
      const colorMap: Record<string, string> = {
        high: 'red',
        medium: 'orange',
        low: 'green',
      };
      const textMap: Record<string, string> = {
        high: '高',
        medium: '中',
        low: '低',
      };
      return <Tag color={colorMap[value] || 'default'}>{textMap[value] || value || '-'}</Tag>;
    },
  },
  {
    title: '出现次数',
    dataIndex: 'appearance_count',
    key: 'appearance_count',
    sorter: (a, b) => a.appearance_count - b.appearance_count,
  },
  {
    title: '首次出现',
    dataIndex: 'first_seen',
    key: 'first_seen',
  },
  {
    title: '最近出现',
    dataIndex: 'last_seen',
    key: 'last_seen',
  },
  {
    title: '备注',
    dataIndex: 'notes',
    key: 'notes',
  },
];

